const actionTypes = require('constants/actionTypes');
const Immutable = require('immutable');

const setInitialState = () => {
    return Immutable.Map().merge({
        showSpinner: false,
        showSpinner2: false,
        informationText: '',
        informationArray: [],
    });
};

const initialState = setInitialState();

const preLoaderReducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case actionTypes.SHOW_SPINNER:
            return state.merge({
                showSpinner: true,
            });

        case actionTypes.HIDE_SPINNER:
            return state.merge({
                showSpinner: false,
                informationText: '',
                informationArray: [],
            });

        case actionTypes.SHOW_SPINNER_2:
            return state.merge({
                showSpinner2: true,
            });

        case actionTypes.HIDE_SPINNER_2:
            return state.merge({
                showSpinner2: false,
                informationText: '',
                informationArray: [],
            });

        case actionTypes.PRELOADER_INFORMATION_TEXT:
            return state.merge({
                informationText: action.informationText,
            });

        case actionTypes.PRELOADER_INFORMATION_ARRAY:
            return state.merge({
                informationArray: action.informationArray,
            });

        default:
            return state;
    }
};

module.exports = preLoaderReducer;
